import React from 'react';
import UpperHeader from './upperHeader';
import StokesLogoFr from '@magento/venia-ui/venia-static/icons/STOKES_FR.svg';
import StokesLogoEn from '@magento/venia-ui/venia-static/icons/STOKES_EN.svg';
import classes from './orderConfirmationHeader.css';
import LogoStokes from '@magento/venia-ui/venia-static/images/logostokes.png';
import { MEDIA_MAX_MOBILE } from '@magento/venia-ui/lib/helpers/mediaQuery';
import Lock from '@magento/venia-ui/venia-static/icons/lock.svg';
import useMediaQuery from 'react-use-media-query-hook';
import { FormattedMessage } from 'react-intl';
import Button from '../CheckoutPage/components/button';
import { useHistory } from 'react-router-dom';
import { useStoreSwitcher } from "@magento/peregrine/lib/talons/Header/useStoreSwitcher";
var OrderConfirmationHeader = () => {
  var isMaxMobile = useMediaQuery(MEDIA_MAX_MOBILE);
  var {
    currentStoreCode
  } = useStoreSwitcher();
  var _logo = currentStoreCode === 'en' ? StokesLogoEn : StokesLogoFr;
  var history = useHistory();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UpperHeader, {
    classes: classes
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.middleContainer
  }, isMaxMobile && /*#__PURE__*/React.createElement(Button, {
    classes: classes,
    onClick: () => {
      history.push('/cart');
    },
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: 'checkout.backToCart',
      defaultMessage: 'Back To Cart'
    })
  }), isMaxMobile && /*#__PURE__*/React.createElement("div", {
    className: classes.secureCheckout
  }, /*#__PURE__*/React.createElement("img", {
    src: Lock,
    alt: 'lock'
  }), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'priceSummary.checkoutButton',
    defaultMessage: 'Secure Checkout'
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      history.push('/');
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: classes.middleLogo,
    src: isMaxMobile ? LogoStokes : _logo,
    alt: 'middleLogo'
  }))));
};
export default OrderConfirmationHeader;